import sample_1 from './twinstarProtectCrossfire.jpg';

export const twinstarProtectCrossfire = {
    sample_1,
};
